import { ColorScheme, colorSchemeToCss } from 'mini-color-utils/lib/ColorScheme';
import { FreeBusyConstants, FreeBusyTypeString } from '../schema/FreeBusyTypeString';

const styles = require('./freeBusyStyles.scss');
const classNames = require('classnames/bind').bind(styles);

const NULL_KEY = 'NULL';

/**
 * Map to store styling computations for freeBusyItemBar
 */
const freeBusyItemBarStyling = {};

/**
 * Gets the css class for the given free busy status to be positioned and styled for a specific item
 * @param freeBusyStatus The free busy status
 */
export function getFreeBusyItemBarClass(
    freeBusyStatus: FreeBusyTypeString,
    iconStyles: string,
    includePositioningClass: boolean = true
) {
    let statusBarStyle: any;
    switch (freeBusyStatus) {
        case FreeBusyConstants.OOF:
            statusBarStyle = styles.awayItemBar;
            break;
        case FreeBusyConstants.Tentative:
            statusBarStyle = styles.tentativeItemBar;
            break;
        case FreeBusyConstants.WorkingElsewhere:
            statusBarStyle = styles.workingElsewhereItemBar;
            break;
        case FreeBusyConstants.Free:
            statusBarStyle = styles.calendarFree;
            break;
        case FreeBusyConstants.Busy:
            statusBarStyle = styles.busyItemBar;
            break;
        case FreeBusyConstants.NoData:
        case FreeBusyConstants.Loading:
        case FreeBusyConstants.NoInformation:
            statusBarStyle = styles.noInformationBar;
            break;
    }
    return classNames(statusBarStyle, { freeBusy: includePositioningClass }, iconStyles);
}

/**
 * Generates the fixed styles for the given item properties
 * @param freeBusyStatus The free busy status
 * @param colorScheme The calendar color scheme
 * @param duration the duration in milliseconds
 */
export function getFreeBusyItemBarStyling(
    freeBusyStatus: FreeBusyTypeString,
    colorScheme: ColorScheme
) {
    const colSchemeKey = colorScheme ? colorScheme.schemePrimary : NULL_KEY;
    const key = freeBusyStatus + '_' + colSchemeKey;
    let result = freeBusyItemBarStyling[key];

    if (!result) {
        const colorCssNormal = colorSchemeToCss(colorScheme);
        const { backgroundColor } = colorCssNormal;

        const returnBlob = {
            backgroundColor: backgroundColor,
            borderColor: backgroundColor,
            backgroundImage: null,
            height: null,
        };

        // colors for specific freebusy statuses
        if (freeBusyStatus === FreeBusyConstants.Free) {
            returnBlob.borderColor = backgroundColor;
            returnBlob.backgroundColor = null;
        }

        result = returnBlob;
        freeBusyItemBarStyling[key] = result;
    }

    return result;
}
